import React from 'react';
import {Modal} from 'antd';
import CreateDelivery from "../../pages/consignor-page/create-delivery";
import i18n from "../../../i18n";

export default function CreateDeliveryModal({isShow, setIsShow, deliveryId, tenderToDelivery = false}) {
  return (
    <Modal
      title={tenderToDelivery ? i18n.t('modals.createDeliveryModal.titles.tender') : i18n.t('modals.createDeliveryModal.titles.order')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={[]}
    >
      <CreateDelivery
        onCreate={() => {
          setIsShow(false)
        }}
        deliveryOrigId={deliveryId}
        tenderToDelivery={tenderToDelivery}
      />
    </Modal>
  );

}
